import { LogService } from './log.service';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { AuthService } from '@yotpo-ui/core';

export abstract class AbstractHttpService {

    constructor(
        private http: HttpClient,
        private log: LogService,
        private authService: AuthService,
    ) { }

    get(url, args = {}) {
        return this.http.get(this.prepareURL(url), { params: args }).pipe(
            map(res => this.handleResponse(res)),
            catchError((response) => this.handleError(response)));
    }

    post(url, args = {}) {
        return this.http.post(this.prepareURL(url), args).pipe(
            map(res => this.handleResponse(res)),
            catchError((response) => this.handleError(response)));
    }

    put(url, args = {}) {
        return this.http.put(this.prepareURL(url), args).pipe(
            map(res => this.handleResponse(res)),
            catchError((response) => this.handleError(response)));
    }

    delete(url) {
        return this.http.delete(this.prepareURL(url)).pipe(
            map(res => this.handleResponse(res)),
            catchError((response) => this.handleError(response)));
    }

    patch(url, args = {}) {
      return this.http.patch(this.prepareURL(url), args).pipe(
        map(res => this.handleResponse(res)),
        catchError((response) => this.handleError(response)));
    }

    abstract getURL(): string;

    private prepareURL(relativeURL: string): string {
        let urlWithAppKey = relativeURL.replace(':app_key', this.authService.getCredentials().appKey);
        return this.getURL() + urlWithAppKey;
    }

    private handleResponse(response: any) {
        return response;
    }

    private handleError(error: Response | any) {
        let errMsg: string;
        let errType: string;
        if (error.error) {
            const errorContent = error.error.status ?? error.error;
            errMsg = errorContent.message;
            errType = errorContent.error_type;
        } else {
            errMsg = error.message ? error.message : error.toString();
            errType = '';
        }
        this.log.error(errMsg);
        return throwError({
            type: errType,
            message: errMsg
        });
    }
}
